'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const components_display_Tooltip_Tooltip = require('../../display/Tooltip/Tooltip.cjs.js');
const utils_uniqueId = require('../../../utils/uniqueId.cjs.js');

const root = "_root_rnz6j_1";
const inputLayout = "_input-layout_rnz6j_84";
const prependAppend = "_prepend-append_rnz6j_91";
const input = "_input_rnz6j_84";
const icon = "_icon_rnz6j_170";
const tooltip = "_tooltip_rnz6j_190";
const styles = {
	root: root,
	inputLayout: inputLayout,
	prependAppend: prependAppend,
	input: input,
	icon: icon,
	tooltip: tooltip
};

const Input = (_a) => {
  var { canClickIconBefore = true, canClickIconAfter = true, disabledText = "Disabled", readOnlyText = "Read-Only", isFocusable = true, layout = "inline", isFullWidth = false, size = "medium", borderRadius } = _a, otherProps = tslib_es6.__rest(_a, ["canClickIconBefore", "canClickIconAfter", "disabledText", "readOnlyText", "isFocusable", "layout", "isFullWidth", "size", "borderRadius"]);
  const props = Object.assign({
    canClickIconBefore,
    canClickIconAfter,
    disabledText,
    readOnlyText,
    isFocusable,
    layout,
    isFullWidth,
    size,
    borderRadius
  }, otherProps);
  const [isFocused, setIsFocused] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);
  const [tooltipId] = React.useState(props.id ? `${props.id}-tooltip` : utils_uniqueId.uniqueId(`Input__tooltip-`));
  const shouldRenderTooltip = props.isDisabled && !!props.disabledText || props.isReadonly && !!props.readOnlyText;
  const renderIconProps = {
    iconSize: props.size === "compact" ? 20 : 24,
    isFocused,
    isHovered
  };
  const iconBefore = props.renderIconBefore && props.renderIconBefore(renderIconProps);
  const iconAfter = props.renderIconAfter && props.renderIconAfter(renderIconProps);
  const derivedState = {
    hasIconBefore: !!iconBefore,
    hasIconAfter: !!iconAfter,
    isFocused,
    isHovered
  };
  return jsxRuntime.jsxs("div", { className: styles.root, "data-append": props.appendContent ? "" : void 0, "data-disabled": props.isDisabled ? "" : void 0, "data-readonly": props.isReadonly ? "" : void 0, "data-errored": props.isErrored ? "" : void 0, "data-full-width": props.isFullWidth ? "" : void 0, "data-icon-after": iconAfter ? "" : void 0, "data-icon-before": iconBefore ? "" : void 0, "data-layout": props.layout, "data-prepend": props.prependContent ? "" : void 0, "data-radius": props.borderRadius, "data-size": props.size, "data-zds": true, onBlur: () => setIsFocused(false), onClick: props.onClick, onFocus: () => setIsFocused(true), onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), role: "presentation", children: [jsxRuntime.jsxs("div", { className: styles.inputLayout, "data-zds": true, children: [iconBefore && jsxRuntime.jsx("div", { className: styles.icon, "data-interactive": props.canClickIconBefore ? "" : void 0, "data-size": props.size, "data-zds": true, children: iconBefore }), props.prependContent && jsxRuntime.jsx("div", { className: styles.prependAppend, "data-layout": props.layout, "data-size": props.size, "data-type": "prepend", "data-zds": true, children: props.prependContent }), props.children({
    "aria-activedescendant": props["aria-activedescendant"],
    "aria-controls": props["aria-controls"],
    "aria-describedby": shouldRenderTooltip ? tooltipId : props["aria-describedby"],
    "aria-errormessage": props.isErrored ? props["aria-describedby"] : void 0,
    "aria-invalid": props.isErrored,
    "aria-label": props["aria-label"],
    "aria-labelledby": props["aria-labelledby"],
    "data-size": props.size,
    autoComplete: props.autoComplete,
    autoFocus: props.autoFocus,
    className: styles.input,
    tabIndex: props.isFocusable ? void 0 : -1,
    disabled: props.isDisabled,
    id: props.id,
    maxLength: props.maxLength,
    name: props.name,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    onKeyDown: props.onKeyDown,
    placeholder: props.placeholder,
    readOnly: props.isReadonly,
    required: props.isRequired,
    role: props.role,
    value: props.value
  }, derivedState), props.appendContent && jsxRuntime.jsx("div", { className: styles.prependAppend, "data-layout": props.layout, "data-type": "append", "data-size": props.size, "data-zds": true, children: props.appendContent }), iconAfter && jsxRuntime.jsx("div", { className: styles.icon, "data-interactive": props.canClickIconAfter ? "" : void 0, "data-size": props.size, "data-zds": true, children: iconAfter })] }), shouldRenderTooltip && jsxRuntime.jsx("div", { className: styles.tooltip, "data-zds": true, children: jsxRuntime.jsx(components_display_Tooltip_Tooltip.Tooltip, { id: tooltipId, position: "south", children: props.isReadonly ? props.readOnlyText : props.disabledText }) })] });
};

exports.Input = Input;
//# sourceMappingURL=Input.cjs.js.map
